<div class="pill-selector">
  <div *ngIf="header" class="header">{{ header }}</div>

  <div class="pill-container">
    <zaver-pill
      *ngFor="let option of options"
      [text]="option.text"
      [isSelected]="getIsOptionSelected(option)"
      (click)="onClickOption(option)"
    >
      {{ option.text }}
    </zaver-pill>
  </div>
</div>
